import React, { MouseEvent as ReactMouseEvent } from "react";
import Settings from "./windows/Settings";
import HowToPlay from "./windows/HowToPlay";
import DynamicValue from "./DynamicValue";

import "./Toolbar.css";
import { Value } from "./core/Value";
import Common from "./Common";

export default class Toolbar extends React.Component<Toolbar.Props, Toolbar.State>
{


    btnSettings: React.RefObject<HTMLDivElement>;


    constructor(props: Toolbar.Props)
    {
        super(props);

        this.state = {
            settings: false
        };

        this.onWindowDown = this.onWindowDown.bind(this);
    }


    componentDidMount(): void
    {
        this.btnSettings = React.createRef();

        window.addEventListener("click", this.onWindowDown);
    }


    componentWillUnmount(): void
    {
        window.removeEventListener("click", this.onWindowDown);
    }


    clickHowToPlay()
    {
        app.addWindow(<HowToPlay />);
    }


    onWindowDown(event: MouseEvent)
    {
        if (this.state.settings)
        {
            let el = event.target as HTMLElement;
            while (el)
            {
                if (el == this.btnSettings.current)
                {
                    return;
                }
                el = el.parentNode as HTMLElement;
            }

            this.closeSettings();
        }

        // const path = event.composedPath();

        // if (this.state.settings && !path.find(el => el == this.btnSettings.current))
        // {
        //     this.closeSettings();
        // }
    }


    clickSettings(e: ReactMouseEvent<HTMLDivElement, MouseEvent>)
    {
        if (this.state.settings)
        {
            return;
        }

        // e.preventDefault();
        // e.stopPropagation();
        console.log("open...");

        this.setState({
            settings: true
        });
    }


    closeSettings()
    {
        this.setState({
            settings: false
        });
    }


    render()
    {
        const lang = window.lang.shared;

        return (
            <div
                id="toolbar"
                className="toolbar bgtex"
            >
                <div className="left">
                    <div className="title"></div>
                    <div
                        className="button orange icon_help down how_to_play"
                        onClick={this.clickHowToPlay.bind(this)}
                    >
                        {lang["how_to_play"]}?
                    </div>
                </div>
                <div className="buttons">
                    <div
                        className="text secondary balance"
                    >
                        {Common.renderCurrency(Value.ID.BALANCE, currency)}&nbsp;
                        <div className="currency">
                            {currency}
                        </div>
                    </div>
                    <div
                        className="button secondary icon_options"
                        onClick={this.clickSettings.bind(this)}
                        ref={this.btnSettings}
                    >
                        <Settings
                            show={this.state.settings}
                            close={this.closeSettings.bind(this)}
                        />
                    </div>
                    <div
                        className="button secondary icon_chat btn_chat"
                        onClick={app.openChat.bind(app)}
                    >

                    </div>
                </div>

            </div>
        );
    }


}

export namespace Toolbar
{
    export interface Props
    {

    }

    export interface State
    {
        settings: boolean;
    }
}